import React from 'react';

import logo from './../../../assets/images/logo.svg';
import './Nav.css';

import AccountDropdown from './../account-dropdown/AccountDropdown';

function Nav() {
  return (
    <nav className="card-body nav d-flex justify-content-between shadow-nav col-lg-2 flex-shrink-0 flex-grow-0">
      <img src={logo} className="w-sm align-self-start" alt="logo" />
      <div className="d-lg-none">
        <AccountDropdown />
      </div>
    </nav >
  );
}

export default Nav;
